import { CarouselItem } from '../../../core/models/item';
import { CategoryMJsEnv } from './category_m_js_env';

/** 画面表示に必要なデータを管理する人 */
export class CategoryMForMakerBrand {
  constructor(private model: CategoryMJsEnv) {
    this.model = { ...model };

    //メーカー・ブランド
    this.model.rrAreaProfileNormalLower = { placementName: "recomRR_mk_03", displayCount: 12, rrAreaItems: [], rrAreaTitle: "", perView: 6 };
    this.model.rrAreaProfileNormalUpper = { placementName: "recomRR_mk_02", displayCount: 20, rrAreaItems: [], rrAreaTitle: "", perView: 6 };
    this.model.rrAreaProfileLeftSide = { placementName: "recomRR_mk_04", rrAreaItems: [], rrAreaTitle: "" };

    this.model.rrAreaProfileM1Sp = { placementName: "recomRR_SP_mk_01", displayCount: 4, rrAreaItems: [], rrAreaTitle: "" };
  }

  getModel(): CategoryMJsEnv {
    return this.model;
  }

  setRrAreaDataNormalLower(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileNormalLower.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileNormalLower.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataNormalUpper(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileNormalUpper.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileNormalUpper.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataLeftSide(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileLeftSide.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileLeftSide.rrAreaTitle = rrAreaTitle;
  }
  
  setRrAreaDataM1Sp(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileM1Sp.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileM1Sp.rrAreaTitle = rrAreaTitle;
  }

  setIsUseful(isUseful: boolean): void {
    this.model.isUseful = isUseful;
  }

  setEnqueteMessage(enqueteMessage: string): void {
    this.model.enqueteMessage = enqueteMessage;
  }

  setIsSendEnquete(isSendEnquete: boolean): void {
    this.model.isSendEnquete = isSendEnquete;
  }
}
